'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    UserInfo = require('../organisms/UserInfo'),
    UserLink = require('../atoms/UserLink'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    UserStore = require('../stores/UserStore'),
    { PropTypes } = React,
    formatDate = require('../utils/formatDate');

require('./Message.less');

var Message = React.createClass({
  mixins: [PureRenderMixin, createStoreMixin(UserStore)],

  propTypes: {
    message: PropTypes.object.isRequired
  },

  getStateFromStores(props) {
    return {
      sender: UserStore.get(props.message.sender)
    };
  },

  render() {
    var { message } = this.props;

    return (
      <div className='Message'>
        <UserInfo user={this.state.sender} noName />
        <div className='Message-content'>
          <UserLink user={this.state.sender} />
          <div className='Message-text'>
            {message.message}
          </div>
          <div className='Message-date'>
            {formatDate(message.created)}
          </div>
        </div>
      </div>
    );
  }
});

module.exports = Message;



/** WEBPACK FOOTER **
 ** ./molecules/Message.jsx
 **/